export const hotelSpokenLanguages = {
  ja: "日本語",
};
